module.exports = __webpack_public_path__ + "img/full7-min.91118902.png";